import { render, staticRenderFns } from "./ProductStoresMap2.vue?vue&type=template&id=84f35aa2&"
import script from "./ProductStoresMap2.vue?vue&type=script&lang=js&"
export * from "./ProductStoresMap2.vue?vue&type=script&lang=js&"
import style0 from "./ProductStoresMap2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports